export type PostalCodeType = 'None' | 'SAPO' | 'SA02' | 'MNFG';
